import { render, staticRenderFns } from "./Home.Performance.vue?vue&type=template&id=21fd9960&scoped=true&"
import script from "./Home.Performance.vue?vue&type=script&lang=js&"
export * from "./Home.Performance.vue?vue&type=script&lang=js&"
import style0 from "./Home.Performance.vue?vue&type=style&index=0&id=21fd9960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd9960",
  null
  
)

export default component.exports